import { useState, useContext, useEffect, useRef } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../Context/MyProvider';

const ImageLoad = ({ url, CustomeStyle, alt }) => {

    const { BaseUrl } = useContext(MyContext);
    const [loaded, setLoaded] = useState(false);
    const [isFallback, setIsFallback] = useState(false);
    const imgRef = useRef(null);

    const defaultImg = secureLocalStorage.getItem("default_image") || "uploads/settings/1772771577662default_pic.png";
    const fallbackUrl = BaseUrl + defaultImg;

    let cleanUrl = url;
    if (url) {
        const match = url.match(/https?:\/\/[^\/]+\/(https?:\/\/.*)/);
        if (match && match[1]) {
            cleanUrl = match[1];
        }
    }

    const displayUrl = (!cleanUrl || isFallback) ? fallbackUrl : cleanUrl;

    const handleError = () => {
        if (!isFallback) {
            setIsFallback(true);
        }
    };

    useEffect(() => {
        if (imgRef.current && imgRef.current.complete) {
            setLoaded(true);
        }
    }, [displayUrl]);

    return (
        <img
            ref={imgRef}
            src={displayUrl}
            alt={alt}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            onError={handleError}
            className={`${CustomeStyle} transition-all duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
        />
    );
};

export default ImageLoad;